/**
 * Promo code and discount related reducer functions
 */

import { EMPTY_PROMO_CODE, EMPTY_CALCULATION } from '../constants'

/**
 * Set promo code
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {string} promocode - Promo code to set
 */
export const setPromoCode = (global, dispatch, promocode) => {
  return {
    promoCode: {
      promoCodeApplied: true,
      promo_code: promocode,
      validCode: false,
      applied: false,
      validated: false,
    },
  }
}

/**
 * Clear promo code
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 */
export const clearPromoCode = (global, dispatch) => {
  return { promoCode: "" }
}

/**
 * Set discount information
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {Object} discountData - Discount data
 */
export const setDiscount = (global, dispatch, discountData) => {
  if (discountData.validCode) {
    return {
      discountName: discountData.name,
      discount: {
        calculated: true,
        name: discountData.name,
        value: discountData.value / 100,
      },
    }
  } else {
    return {
      discountName: "",
      discount: { ...EMPTY_CALCULATION },
    }
  }
}

/**
 * Clear discount
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 */
export const clearDiscount = (global, dispatch) => {
  if (global.discount.calculated !== false) {
    return {
      discountName: "",
      discount: { ...EMPTY_CALCULATION },
    }
  }
  return {}
}
